import { render, staticRenderFns } from "./PriceguardActions.vue?vue&type=template&id=984a1c3e"
import script from "./PriceguardActions.vue?vue&type=script&lang=js"
export * from "./PriceguardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('984a1c3e')) {
      api.createRecord('984a1c3e', component.options)
    } else {
      api.reload('984a1c3e', component.options)
    }
    module.hot.accept("./PriceguardActions.vue?vue&type=template&id=984a1c3e", function () {
      api.rerender('984a1c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceguardActions.vue"
export default component.exports